export const formatInputAmount = (amount: number) => {
  const [numbersBeforeDot, numbersAfterDot] = amount.toFixed(2).split('.');
  const hasOneDecimal = !!numbersAfterDot && numbersAfterDot.length === 1;
  const hasTwoDecimal = !!numbersAfterDot && numbersAfterDot.length >= 2;

  if (amount === 0) {
    return '0.00';
  } else if (hasOneDecimal) {
    return `${numbersBeforeDot}.${numbersAfterDot}0`;
  } else if (hasTwoDecimal) {
    return `${numbersBeforeDot}.${numbersAfterDot}`;
  } else {
    return `${numbersBeforeDot}.00`;
  }
};

export const formatAmount = (amount: number, locale = 'en-US') =>
  '$ ' +
  amount.toLocaleString(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const formatAndRoundAmount = (amount: number, locale = 'en-US') => {
  const roundedAmount = Math.round(amount);
  return (
    '$ ' +
    roundedAmount.toLocaleString(locale, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
  );
};
